export default __webpack_public_path__ + "static/media/ico-anterior.0482a734.svg";